<button
  [kzTooltip]="socialShareTmpl"
  tooltipPosition="top-left"
  [tooltipPersistDelay]="500"
  class="kz-share--icon"><kz-icons name="share"></kz-icons></button>
<ng-template #socialShareTmpl>
  <div class="kz-social-share--tooltip">
    <button appSocialShare [facebook]="{u: postLink}" ><kz-icons name="social_facebook"></kz-icons></button>
    <button appSocialShare [twitter]="{url: postLink, text:postDescription }" ><kz-icons name="social_twitter"></kz-icons></button>
    <button appSocialShare [pinterest]="{url:postLink, media: postMainMediaUrl, description:postDescription}"><kz-icons name="social_pinterest"></kz-icons></button>
  </div>
</ng-template>
